import React, { useState, useEffect } from "react";
import BASE_URL from "../../config";

export default function Holidays() {

  const [form, setForm] = useState({
    date: "",
    name: ""
  });

  const [data, setData] = useState([]);

  // 🔄 Fetch holidays
  useEffect(() => {
    fetchData();

    const interval = setInterval(fetchData, 5000);
    return () => clearInterval(interval);
  }, []);

  const fetchData = () => {
   fetch(`${BASE_URL}/api/getHolidays.php?t=${Date.now()}`)
      .then(res => res.json())
      .then(result => setData(result))
      .catch(err => console.error(err));
  };

  // ✏️ handle input
  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  // 🚀 submit
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("date", form.date);
    formData.append("name", form.name);

   fetch(`${BASE_URL}/api/saveHoliday.php`, {
      method: "POST",
      body: formData
    })
      .then(res => res.text())
      .then(msg => {
        alert(msg);
        setForm({ date: "", name: "" });
        fetchData();
      });
  };

  const deleteHoliday = (id) => {
 fetch(`${BASE_URL}/api/deleteHolidays.php?id=${id}`)
    .then(res => res.json())
    .then(data => {
      alert(data.message);
      fetchData();
    })
    .catch(err => {
      console.error(err);
      alert("Delete failed ❌");
    });
};

  return (
    <div className="holiday-page">

      {/* FORM */}
      <div className="form-card">
        <h2>➕ રજા ઉમેરો</h2>

        <form onSubmit={handleSubmit}>

          <input
            type="date"
            name="date"
            value={form.date}
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="name"
            placeholder="રજાનું નામ"
            value={form.name}
            onChange={handleChange}
            required
          />

          <button type="submit">સેવ કરો</button>

        </form>
      </div>

      {/* TABLE */}
      <div className="holiday-section">
        <h2>બેંક રજાઓ</h2>

        <table className="holiday-table">
          <thead>
            <tr>
              <th>#</th>
              <th>તારીખ</th>
              <th>રજાનું નામ</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>

            {data.length > 0 ? (
              data.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>{item.date}</td>
                  <td>{item.name}</td>
                  <td>
                    <button style={{
            background: "#b41212",
            color: "#fff",
            border: "none",
            padding: "5px 0px",
            cursor: "pointer",
            width:"100px"
          }} onClick={() => deleteHoliday(item.id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">કોઈ રજા નથી</td>
              </tr>
            )}

          </tbody>
        </table>
      </div>

    </div>
  );
}